import { createUseStyles } from 'react-jss';

const styles = {
  formContent: {
    width: '90%',
    marginBottom: '6rem',
  },
  sponsorSelect: {
    marginBottom: '4rem',
  },
  textAreaDescription: {
    fontSize: '1.6rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
